import $ from "jquery";
import React, { Component } from "react";
import { formValueSelector, Field, change } from "redux-form";
import { connect } from "react-redux";
import { Row, Column } from "react-foundation";

import { getMainDoorColours } from "selectors/index.js";

import { getDoorOptions } from "actions";
import Loading from "components/Loading";
import SwitchInput from "components/SwitchInput";
import Popup from "components/Popup";
import ChipsGrid from "components/ChipsGrid";
import utils from "utils";
import WhiteInteriorPopup from "../../../components/WhiteInteriorPopup";
import ImageResolver from "containers/ImageResolver";
import InputError from "../../../components/InputError";
import ThemeButton from "../../../components/ThemeButton";
import SeparatingLine from "../../../components/SeparatingLine";
import FormWrapper from "../../FormWrapper";
import FormHeader from "../../../components/FormHeader";
import { updatePreviousSelection } from '../../../actions';

class SelectColour extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedCategory: 1
        };
    }

    render() {
        let { colours, input } = this.props;

        if ($.isEmptyObject(colours)) {
            return <Loading />;
        }

        let filteredColours = utils.filterObject(colours, colour => colour.category === this.state.selectedCategory);

        return (
            <div>
                <Row collapseOnSmall uncollapseOnMedium>
                    <Column small={12}>
                        <span
                            className={"colour-type-label" + (this.state.selectedCategory === 1
                                ? " selected"
                                : "")}
                            onClick={() => this.setState({ selectedCategory: 1 })}>
                            Standard<span>£</span>
                        </span>

                        <span
                            className={"colour-type-label" + (this.state.selectedCategory === 2
                                ? " selected"
                                : "")}
                            onClick={() => this.setState({ selectedCategory: 2 })}>
                            Special<span>££</span>
                        </span>

                        <span
                            className={"colour-type-label" + (this.state.selectedCategory === 3
                                ? " selected"
                                : "")}
                            onClick={() => this.setState({ selectedCategory: 3 })}>
                            Premium<span>£££</span>
                        </span>
                    </Column>
                </Row>

                <Row isColumn>
                    <ChipsGrid
                        key={this.state.selectedCategory}
                        colours={filteredColours}
                        selectedId={input.value}
                        onChange={input.onChange} />
                </Row>

                <InputError metas={this.props.meta} />
            </div>
        );
    }
}

class ColourForm extends Component {
    componentDidMount() {
        // let itemTypeId = 1; // window

        this
            .props
            .getDoorOptions(this.props.doorTypeId, this.props.doorRoomId);
    }
    componentDidUpdate() {
        let { defaultColourId, selectedColour, colours, dispatch, previousSelection } = this.props;
        if (!selectedColour.id) {
            if (colours.length > 0) {
                // do something
                dispatch(change("DoorWizard", "DoorColourId", previousSelection.DoorPvcColourId || defaultColourId));
                if (previousSelection.DoorPvcColourWhiteInterior)
                    dispatch(change("DoorWizard", "DoorColourInterior", previousSelection.DoorPvcColourWhiteInterior));
            }
        }
    }

    componentWillUpdate(newProps){
        let {hasWhiteInterior, dispatch} = this.props;

        if(!newProps.hasWhiteInterior && hasWhiteInterior){
            dispatch(change("DoorWizard", "DoorColourInterior", false));

        }
    }

    onSubmit(values) {
        if (values.DoorColourId !== this.props.previousSelection.DoorPvcColourId) {
            this.props.updatePreviousSelection({
                DoorPvcHandleColour: null,
                DoorPvcHandleType: null
            });
        }

        this.props.updatePreviousSelection({
            DoorPvcColourId: values.DoorColourId,
            DoorPvcColourWhiteInterior: values.DoorColourInterior
        });

        this.props.onSubmit(values);
    }

    render() {
        let { selectedColour, colours, doorColourInterior, hasWhiteInterior } = this.props;

        let colourIdFilter = selectedColour.id;

        if (doorColourInterior && selectedColour.relatedColourId) {
            colourIdFilter = selectedColour.relatedColourId;
        }

        return (
            <form
                className="ColourForm"
                onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}>
                <FormHeader
                    title={"Colour & finish"}
                    subtitle={"We can supply a wide range of finish colours and textures"} />

                <SeparatingLine />

                <FormWrapper>
                    <Row collapseOnSmall uncollapseOnMedium>
                        <Column pushOnLarge={7} large={5} className="preview-container">
                            <ImageResolver
                                query={{
                                    productId: this.props.doorTypeId,
                                    extraId: 0
                                }}
                                filters={{
                                    colourId: colourIdFilter
                                }} />
                        </Column>
                        <Column className="colour-name-container" showOnlyFor="small">
                            {selectedColour.name}
                        </Column>
                        <Column
                            pullOnLarge={7}
                            large={5}
                            className="swatch-selector-container">
                            <Row isColumn>
                                <Field name="DoorColourId" component={SelectColour} colours={colours} />
                            </Row>
                            <Row isColumn>
                                <Field
                                    name="DoorColourInterior"
                                    component={SwitchInput}
                                    disabled={!hasWhiteInterior}>
                                    White interior
                                    <Popup component={WhiteInteriorPopup}>
                                        <span className="info-icon">i</span>
                                    </Popup>
                                </Field>
                            </Row>
                        </Column>
                    </Row>
                </FormWrapper>

                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={this.props.previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("DoorWizard");
    let doorTypeId = valueSelector(state, "DoorTypeId") || 7;
    let doorRoomId = valueSelector(state, "DoorRoomId") || 21;
    let doorColourId = valueSelector(state, "DoorColourId");
    let doorColourInterior = valueSelector(state, "DoorColourInterior");

    let colours = getMainDoorColours(state);

    let selectedColour = {};

    if (doorColourId)
        selectedColour = colours.filter(c => c.id === doorColourId)[0] || {};

    let hasWhiteInterior = selectedColour.relatedColourId !== 0;

    let selectedType = utils.getValueById(state.Door.Types, doorTypeId);

    let defaultColourId = selectedType.defaultColourId;

    if (!defaultColourId && colours.length > 0) {
        defaultColourId = colours[0].id;
    }

    return {
        colours,
        selectedColour,
        doorTypeId,
        doorColourInterior,
        hasWhiteInterior,
        defaultColourId,
        doorRoomId,
        previousSelection: state.PreviousSelection
    };
};

export default connect(mapStateToProps, { getDoorOptions, updatePreviousSelection })(ColourForm);



// WEBPACK FOOTER //
// ./src/containers/DoorForm/uPVC/ColourForm.js